<div class="au-linked-object-list">
	@if (items.length) {
		@for (item of dataItems | slice: 0 : maxItemsInRow; track item) {
			<div class="button-wrapper">
				<au-linked-object-btn
					[text]="item.nameSelectedByKey"
					(clicked)="openLink($event, item)"
					[matTooltip]="item.name ? item.name : item.nameSelectedByKey"
				></au-linked-object-btn>
			</div>
		}
		@if (maxItemsInRow && maxItemsInRow < dataItems.length) {
			<div class="button-wrapper">
				<au-linked-object-btn
					[clickable]="false"
					[text]="'+' + (dataItems.length - maxItemsInRow)"
				></au-linked-object-btn>
			</div>
		}
	} @else {}
</div>
